import { mantineColors } from '@/theme/mantineColors';

type PaletteName = Exclude<keyof typeof mantineColors, 'background'>;

const PALETTE_NAMES = Object.keys(mantineColors).filter((k): k is PaletteName => k !== 'background');

const isPaletteName = (name: string): name is PaletteName => PALETTE_NAMES.some(n => n === name);

const COLOR_TOKEN_RE = new RegExp(`\\b(${PALETTE_NAMES.join('|')})\\.([1-9])\\b`, 'g');

const BROAD_TOKEN_RE = /\b([a-zA-Z][a-zA-Z0-9]*)\.([1-9])\b/g;

const resolveToken = (name: PaletteName, shade: string) => {
  const palette = mantineColors[name];
  return Object.entries(palette).find(([k]) => k === shade)?.[1];
};

/**
 * CSS 값 문자열에서 `colorName.shade` 토큰(예: `red.4`)을 defaultTheme 기반 hex 색상으로 치환한다.
 * `word.[1-9]` 패턴이 감지됐는데 유효한 팔레트 이름이 아니면 에러를 throw한다.
 */
export const resolveColorTokens = (value: string): string => {
  for (const [match, name] of Array.from(value.matchAll(BROAD_TOKEN_RE))) {
    if (!isPaletteName(name)) {
      throw new Error(`resolveColorTokens: '${match}' - '${name}'은 유효한 팔레트 이름이 아닙니다.`);
    }
  }
  return value.replace(COLOR_TOKEN_RE, (match, name, shade) => resolveToken(name, shade) ?? match);
};
